import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import React, { Children } from 'react';
import StickyBox from 'components/StickyBox';
import InlineList from 'components/InlineList';
function StickyButtonPanel(_ref) {
  var children = _ref.children;
  var childrenCount = Children.toArray(children).length;
  return /*#__PURE__*/React.createElement(StickyBox, {
    placement: "bottom",
    borderBottomRadius: "inherit",
    textAlign: "center",
    p: "m",
    mt: "-m"
  }, childrenCount > 1 ? /*#__PURE__*/React.createElement(InlineList, {
    spacing: "xs"
  }, children) : children);
}
export default StickyButtonPanel;